import * as React from 'react';

import { DispensaryContext } from '../dispensary/DispensaryProvider';
import ProductDetailPage from './ProductDetailPage';

import PropTypes from 'prop-types';

/**
 * This page/view is mostly for SEO, currently a product card click
 * will display a modal not a full page view
 * 
 * Note: viewing this page would likely flush cart items from a different dispensary
 */
const ProductDetailWithContext = ({dispensaryId, itemId}) => {

  const { dispensary, setDispensaryId } = React.useContext(DispensaryContext);
  
  React.useEffect(() => {
    if (dispensaryId && dispensaryId !== dispensary?.id) {
       setDispensaryId(dispensaryId);
    }
  }, [dispensary, dispensaryId, setDispensaryId]);

  return (
    dispensaryId  
    ? <ProductDetailPage dispensaryId={dispensaryId} itemId={itemId} />
    : null 
  );
}  
// From router
ProductDetailWithContext.propTypes = {
  dispensaryId: PropTypes.string,
  itemId: PropTypes.string
};

export default ProductDetailWithContext;